import { Select } from "antd";
import { useEffect, useState } from "react";
import { getOptionLabel } from "../../../hooks/form-helpers";

import axios from "../../../utils/axios";

import HexLoader from "../../HexLoader";

import "./style.css";
import { handleError } from "../../../utils/common-utils";

const { Option } = Select;

const getLabelTitles = (values, options, valueKey, labelKey, metaKey) => {
  return values.map((valueItem) => {
    const option = options.find(
      (optionItem) => optionItem[valueKey] === valueItem
    );

    return getOptionLabel(metaKey, labelKey, option);
  });
};

const APISelect = (props) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const {
    apiURL,
    labelKey,
    metaKey,
    valueKey,
    apiKey,
    value,
    onChange,
    mode,
    valueOnly,
    label,
    disabled,
    onError,
    showSearch,
    placeholder,
    labelPlaceholder
  } = props;

  useEffect(() => {
    setOptions([]);

    if (apiURL) {
      setLoading(true);
      axios
        .get(apiURL)
        .then(({ data }) => {
          apiKey ? setOptions(data[apiKey]) : setOptions(data);
          setLoading(false);
        })
        .catch((error) => {
          const errorMessage = handleError(error);
          onError && onError(errorMessage);
          setLoading(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiKey, apiURL]);

  const handleChange = (value, { children }) => {
    let optionLabel = children;

    if (mode === "multiple" && !valueOnly) {
      optionLabel = getLabelTitles(
        value,
        options,
        valueKey,
        labelKey,
        valueKey
      );
    }

    if (valueOnly) {
      const optionValue = mode === "multiple" && !value.length ? "" : value;
      onChange(optionValue);
    } else {
      onChange({ optionValue: value, optionLabel });
    }
  };

  const selectProps = {
    ...(mode && { mode }),
    sise: "small",
    defaultValue: value || (mode === "tags" ? "" : []),
    onChange: handleChange,
    disabled,
    value: value || (mode === "tags" ? "" : []),
    ...(showSearch && {
      showSearch,
      optionFilterProp: "children",
      filterOption: (input, option) =>
        (option.children.toLowerCase() || "").includes(input.toLowerCase()),
    }),
  };

  if (loading) return <HexLoader className={"select-loader"} />;

  return (
    <Select {...selectProps} id={label} placeholder={placeholder}>
      {options.map((option) => (
        <Option value={option[valueKey]} key={option[valueKey]}>
          {`${getOptionLabel(metaKey, labelKey, option)}${labelPlaceholder || ""}`}
        </Option>
      ))}
    </Select>
  );
};

export default APISelect;
